<div
  class="min-h-screen flex flex-col bg-age-cream text-age-green selection:bg-age-gold selection:text-white font-segoe"
>
  <header class="flex justify-center pt-10 pb-6">
    <img src="logo.png" alt="AGE Logo" class="w-62 md:w-56 h-auto" />
  </header>

  <main class="flex-1 flex flex-col items-center px-4 pb-20 text-center">
    <div
      class="inline-flex items-center gap-4 bg-age-beige py-2 px-6 rounded-full mb-10 text-sm font-semibold shadow-sm border-age-brown/10 border"
    >
      <div class="flex items-center gap-2">
        <lib-calendar></lib-calendar>
        <span class="tracking-wide !text-age-brown">21, 22 ET 23 MAI 2026</span>
      </div>
      <span class="!text-age-brown">|</span>
      <div class="flex items-center gap-2">
        <lib-pin></lib-pin>
        <span class="!text-age-brown">HOTEL HILTON DOUBLE TREE CASABLANCA</span>
      </div>
    </div>

    <h1
      class="font-bebas text-5xl md:text-6xl lg:text-7xl leading-[0.9] tracking-wider mb-8"
    >
      16<sup class="!lowercase">ème</sup> RENCONTRES NATIONALES<br />
      <span class="text-age-gold block mt-2">DE GÉRONTOLOGIE</span>
    </h1>

    <div
      class="max-w-2xl text-age-primary text-base md:text-lg mb-14 leading-relaxed font-normal"
    >
      <p>
        Rejoignez-nous pour échanger sur les avancées et l'avenir de la
        gérontologie.
      </p>
      <p>Choisissez votre type d'inscription ci-dessous.</p>
    </div>

    <div
      class="flex flex-col md:flex-row gap-8 w-full max-w-5xl justify-center items-stretch"
    >
      <div
        class="group relative flex flex-col items-center bg-white border border-age-price-b rounded-[2rem] p-10 md:p-14 transition-all duration-500 hover:-translate-y-2 hover:shadow-card flex-1 overflow-hidden"
      >
        <div
          class="absolute -top-6 -right-6 w-30 h-30 bg-[#F2EDE4] rounded-bl-full z-0 transition-transform group-hover:scale-110"
        ></div>
        <div
          class="w-20 h-20 bg-age-footer rounded-full flex items-center justify-center mb-8"
        >
          <lib-user></lib-user>
        </div>

        <h2 class="font-bebas text-3xl mb-4 tracking-wide">
          Inscription Individuelle
        </h2>

        <p class="text-age-primary mb-10 text-sm leading-relaxed font-normal">
          Pour les participants individuels, avec ou sans hébergement inclus.
        </p>

        <button
          class="mt-auto flex items-center gap-2 font-bold text-age-brown uppercase text-sm tracking-wide relative after:absolute after:left-0 after:-bottom-1 after:h-[2px] after:w-0 after:bg-[#5A4838] after:transition-all after:duration-300 hover:after:w-full hover:cursor-pointer hover:gap-4"
          (click)="redirectTo(true)"
        >
          <span class="leading-none"> Commencer l'inscription </span>
          <lib-arrow-right></lib-arrow-right>
        </button>
      </div>

      <div
        class="group relative flex flex-col items-center bg-white border border-age-price-b rounded-[2rem] p-10 md:p-14 transition-all duration-500 hover:-translate-y-2 hover:shadow-card flex-1 overflow-hidden"
      >
        <div
          class="absolute -top-6 -right-6 w-30 h-30 bg-age-footer rounded-bl-full z-0 transition-transform group-hover:scale-110"
        ></div>

        <div
          class="w-20 h-20 bg-age-footer rounded-full flex items-center justify-center mb-8"
        >
          <lib-group></lib-group>
        </div>

        <h2 class="relative z-10 font-bebas text-3xl mb-4 tracking-wide">
          Inscription Groupe
        </h2>

        <p
          class="relative z-10 text-age-primary mb-10 text-sm leading-relaxed font-normal"
        >
          Pour les entreprises et organisations souhaitant inscrire plusieurs
          participants.
        </p>
        <button
          class="mt-auto flex items-center gap-2 font-bold text-age-brown uppercase text-sm tracking-wide relative after:absolute after:left-0 after:-bottom-1 after:h-[2px] after:w-0 after:bg-[#5A4838] after:transition-all after:duration-300 hover:after:w-full hover:cursor-pointer hover:gap-4"
          (click)="redirectTo(false)"
        >
          <span class="leading-none">Inscrire mes participants</span>
          <lib-arrow-right></lib-arrow-right>
        </button>
      </div>
    </div>
  </main>
  <lib-footer></lib-footer>
</div>
